import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, LinearProgress } from '@material-ui/core';
import React from 'react'
import { dispositionFilter, DispositionFilter, generalFilter, RsdDispositionFilter,rsddispositionFilter } from '../../../../util/filter';
import CloseIcon from '@material-ui/icons/Close';
import { LSDBCoreTable } from '../../../common/LSDBCoreTable';
import { useHistory } from 'react-router-dom';
import { useReportSequenceDefinitions } from '../../reportSequenceDefinitionQueries';
import { ErrorMessage } from '../../../common/ErrorMessage';




const RSDList = () => {
    const history = useHistory();
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = () => {
        setOpen(true);  
    };

    const {
        data: rsdData,
        error: rsdError,
        isLoading: isLoadingRsd,
        isError: isErrorRsd,
      } = useReportSequenceDefinitions();

    const columns = React.useMemo(
        () => [
            {
                Header: "Id",
                accessor: "id",
                maxWidth: 40,
                filter: generalFilter,
                Cell: ({ row }: any) => (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            history.push(`report_sequence_definition/${row.values.id}`);
                            console.log({ location: history.location });
                          }}
                    >
                        {row.values.id}
                    </Button>
                ),
            },
            { Header: "Name", accessor: "name", filter: generalFilter },
            {
                Header: "Disposition",
                accessor: "disposition_name",
                Filter: RsdDispositionFilter,
                filter: rsddispositionFilter,
            },
            { Header: "Version", accessor: "version", filter: generalFilter },
        ],
        []
    );


    if (isLoadingRsd) {
        return <LinearProgress />;
      }
    
      if (isErrorRsd) {
        return <>{isErrorRsd && <ErrorMessage error={rsdError} />}</>;
      }
    
    return (
        <div>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={4}
            >
                <Grid item xs={12}>
                    <Typography variant="h3">Report Sequence Definitions</Typography>
                </Grid>
                <Grid item container xs={12} justifyContent="center">
                    <Grid item xs={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleOpen}


                        >
                            Add RSD
                        </Button>
                    </Grid>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                        fullWidth={false}>
                        <DialogTitle id="id">
                            <div>
                                <Box display="flex" alignItems="center">
                                    <Box flexGrow={1} >{"Choose Your Option"}</Box>
                                    <Box>
                                        <IconButton onClick={handleClose}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>
                                </Box>
                            </div>
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => history.push("report_sequence_definition/new_rsd")}
                                    >
                                        New RSD
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        // disabled
                                        fullWidth
                                        onClick={() => history.push("report_sequence_definition/rsd")}
                                    >
                                        Existing RSD
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                        </DialogActions>
                    </Dialog>
                </Grid>
                <Grid item xs={12}>
                    {rsdData && (
                            <Grid item xs={12}>
                              <LSDBCoreTable
                                columns={columns}
                                data={rsdData}
                                noGeneralFilterColumns={["disposition_name"]}
                              />
                            </Grid>
                          )}
                </Grid>
            </Grid>
        </div>
    )
}

export default RSDList;